import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { MistralOptionsInterface } from '../../../../app/interfaces/ProviderOptionsInterface';

export interface MistralOptionsProps {
  options: MistralOptionsInterface;
  onChange: (options: MistralOptionsInterface) => void;
}

const MistralOptions: React.FunctionComponent<MistralOptionsProps> = (props: MistralOptionsProps) => {
  const { options, onChange } = props;
  const { t } = useTranslation();

  const handleSafePromptToggle = (checked: boolean) => {
    onChange({
      ...options,
      safePrompt: checked
    });
  };

  const handleRandomSeedChange = (value: number | null) => {
    onChange({
      ...options,
      randomSeed: value || undefined
    });
  };

  return (
    <div className="mistral-options">
      <h4 className="text-lg mb-2">{t('provider_options.mistral.title')}</h4>
      
      <div className="p-field-checkbox mb-3">
        <Checkbox
          inputId="mistral-safe-prompt"
          checked={options.safePrompt || false}
          onChange={(e) => handleSafePromptToggle(e.checked)}
        />
        <label htmlFor="mistral-safe-prompt" className="ml-2">
          {t('provider_options.mistral.safe_prompt')}
        </label>
      </div>

      <div className="p-field mb-3">
        <label htmlFor="mistral-random-seed" className="block mb-1">
          {t('provider_options.mistral.random_seed')}
        </label>
        <InputNumber
          id="mistral-random-seed"
          value={options.randomSeed}
          onChange={(e) => handleRandomSeedChange(e.value)}
          min={1}
          placeholder={t('provider_options.mistral.random_seed_placeholder')}
          className="w-full"
        />
        <small className="text-xs text-gray-500 block mt-1">
          {t('provider_options.mistral.random_seed_help')}
        </small>
      </div>
    </div>
  );
};

export default MistralOptions;